const chatComposeValid = (input) => {
  const validChars = /^[\s\S]{1,20000}$/.test(input);

  // Check we don't have a string with only spaces and carriage returns
  const noText = /^[\s]*$/.test(input);

  return (validChars && (!noText));
};

export default chatComposeValid;
